import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { bottom } from '@popperjs/core';
import Chart from 'chart.js/auto';
import { DoughnutChartData } from './doughnut-chart-data.interface';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-doughnut-view',
    templateUrl: './doughnut-view.component.html',
    styleUrls: ['./doughnut-view.component.scss'],
    imports: [NgClass]
})
export class DoughnutViewComponent {

  public chart: any;
  chartLegendSelector = "[data-results-chart-legends]";
  @Input() height: number = 115;
  @Input() width: number = 115;
  @Input() customClass: string = ''; 
  @Input() isCircleVisible: boolean = false
  @Input("values")
set values(values: { doughnutId: string, legendId: string, chartData: DoughnutChartData }) {
  if (!values) {
    return; // Exit if values are undefined
  }
  this.doughnutId = values.doughnutId;
  this.legendId = values.legendId;
  this.percentData = values.chartData.percentData
  this.chartData = {
    ...{
      names: [...values.chartData.names],
      color: [...values.chartData.color],
      header: values.chartData.header,
      total: values.chartData.total,
      data: [...values.chartData.data],
    },
  };

  // Set the totalText to totalResponses for display in the center
  this.totalText = typeof values.chartData.total === 'number' 
    ? values.chartData.total : 
0; // Convert or fallback to 0
  if (this.chart) this.chart.destroy();
  const canvas = document.getElementById(this.doughnutId);
  if (canvas) {
    this.createChart(this.doughnutId);
  }
}
  doughnutId: string = '';
  chartData: DoughnutChartData = {
    header: '',
    names: [],
    data: [],
    color: [],

    // legendPosition: ''
  };
  public legendId: string = '';
  public totalText: number = 0;
  percentData: any = [];
  ngAfterViewInit(): void {
    const canvas = document.getElementById(this.doughnutId);
    if (canvas) {
      this.createChart(this.doughnutId);
    }
  }
  createChart(chartId) {
    const that = this;
    const htmlLegendPlugin = {
      id: 'htmlLegend',
      afterUpdate(chart, args, options) {
        const renderLabels = (chart) => {
          const { data } = chart;
          return data.datasets[0].data
            .map(

              (_, i) => {
                if (that.percentData && that.percentData.length && that.percentData[i]) {
                  return `
                  <div class="legend-item legend-item-${data.labels[i]}" >
                   <span style="margin-right: 120px; opacity:0.7;">${data.labels[i]}</span>
                   <div style="font-weight: 600">${data.datasets[0].data[i]} (${that.percentData[i]}%)</div>
               </div>
             `
                } else {
                  return `
                   <div  style="display: flex; flex-direction: column;"> 
                 <div style="display: inline-flex; align-items: start; flex-shrink:0">
                ${that.isCircleVisible ? `<span style="background-color: ${data.datasets[0].backgroundColor[i]}; display: inline-block; width: 10px; height: 10px; border-radius:2px;  margin-right: 7px; margin-top:5px; flex-shrink:0;"></span>
                 `: ''}
                  <div style="display: flex; flex-direction: column;">
                    <span style="font-weight: 500;">${data.labels[i]}</span>
                    <strong style="font-weight: 600;">${data.datasets[0].data[i]}</strong>
                  </div>
                </div>
               </div>
             `
                }
              }
            )
            .join("");
        };
        const chartLegendEL = document.getElementById(that.legendId);
        if (chartLegendEL) chartLegendEL.innerHTML = renderLabels(chart);
      }
    };
    const doughnutTextPlugin: any = {
      id: 'doughnutTextPlugin',
      beforeDraw(chart: any) { // Use beforeDraw to avoid overlap with tooltip
        if (chart.config.type !== 'doughnut') {
          return;
        }
    
        const { ctx, chartArea } = chart;
        const { top, right, bottom, left } = chartArea;
        const centerX = (left + right) / 2;
        const centerY = (top + bottom) / 2;
    
        ctx.save();
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = '#000000';
    
        // Draw total count
        ctx.font = 'bolder 25px Lato';
        // ctx.fillText(that.totalText.toString(), centerX, centerY - 5);
    
        // Draw "Responses" text
        ctx.font = '8px Lato';
        // ctx.fillText('Responses', centerX, centerY + 15);
    
        ctx.restore();
      },
    };
       
    this.chart = new Chart(chartId, {
      type: 'doughnut',
      data: {
        labels: this.chartData.names,
        datasets: [
          {
            data: this.chartData.data,
            backgroundColor: this.chartData.color,
            hoverOffset: 0, // Ensure no zoom effect by setting hoverOffset to 0
            borderWidth: 0, // Remove gaps between segments
          },
        ],
      },
      options: {
        responsive: false,
        hover: {
          mode: 'nearest', // Use a valid mode; 'nearest' is the most neutral
        },
        plugins: {
          legend: {
            display: false,
            position: 'bottom',
          },
          tooltip: {
            enabled: true,
            displayColors: false, // Remove color boxes
            backgroundColor: '#FFFFFF', // Set tooltip background color to white
            // borderColor: '#CCCCCC', // Tooltip border color
            borderWidth: 1, // Tooltip border width
            titleColor: '#000000', // Title color
            bodyColor: '#000000', // Body text color
            position: 'nearest', // Ensure tooltip appears near the cursor
            intersect: true, // Limit tooltip display to hovered segment
            callbacks: {
              title: function () {
                return '';
              },
              label: function (tooltipItem) {
                const dataset = tooltipItem.dataset;
                const dataIndex = tooltipItem.dataIndex;
                const label = tooltipItem.label || '';
                const value = dataset.data[dataIndex];
                return `${label}: ${value}`;
            },
            },
          },
        },
        animation: {
          duration: 0, // Disable animation (optional, for instant updates)
        },
      },
      plugins: [htmlLegendPlugin, doughnutTextPlugin],
    });
    
     
}
  ngDestroy() {
    if (this.chart)
      this.chart.destroy();
  }

}
